import { ROUTES } from '@/router/routeNames'

export default [
  {
    name: ROUTES.INSIGHTS,
    path: 'insights',
    component: () => import('./pages/InsightsIndex.vue'),
    meta: {
      rightyPrompts: [
        {
          label: 'Pain points',
          drawerLabel: 'Uncover audience pain points',
          prompt: 'Analyze the open-ended survey responses to identify the top pain points my audience is experiencing. What are they struggling with most?'
        },
        {
          label: 'Goals',
          drawerLabel: 'Discover audience goals and aspirations',
          prompt: 'Based on the survey responses and visitor data, what are the primary goals and aspirations of my audience? What are they trying to achieve?'
        },
        {
          label: 'Sentiment',
          drawerLabel: 'Analyze audience sentiment and language',
          prompt: 'Analyze the sentiment in my survey responses. What themes emerge? How are people feeling about their challenges and what language are they using?'
        },
        {
          label: 'Content gaps',
          drawerLabel: 'Find gaps in my content strategy',
          prompt: 'Based on what my audience is asking and talking about, what content am I missing? What topics should I create content around?'
        }
      ]
    }
  }
]
